import React, {Component} from 'react';
import {Link} from 'react-router'
import './ga';

import ReactPixel from 'react-facebook-pixel';

export default class Top extends Component {

  // onload
  componentDidMount() {
    if ("/lpThanks" === window.location.pathname) {
      ReactPixel.init('185828338818169');
      ReactPixel.pageView(); // For tracking page view
      ReactPixel.track( "CompleteRegistration" )
    }
  }
  render() {
    return (
    <div id="wrapper">
      <title>MyRate</title>
      <meta name="viewport" content="width=480" />
      <div id="" className="wrapper-lp">
        <div className="header">
          <img className="header-title" src="/img/lp/logo_white.png" alt="" />

        </div>
        <div className="webWrap">
          <div className="wrapCover-thanks">
            <div className="wrapCover__lp-contentBlock clearfix">
              <div className="contentService-bottom">
                <div className="formBlock-bottom">
                  <p className="title">ご登録ありがとうございます。</p>
                  <p className="sub-title-thanks">ベータ版がリリースされましたら、メールにてご連絡差し上げます。</p>
                    <Link to={"/lp"} className="submitForm">戻る</Link>
                </div>
              </div>
            </div>
            <div className="wrapCover__formBlock-lp-under">
              <Link to="http://www.n-village.co.jp/" target="_blank">
                <p className="f_copy">Produced by N-village</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
 }
}



// WEBPACK FOOTER //
// ./src/lpThanks.js